<div class="dialog-form" [formGroup]="formGroup">

    <p-fieldset *ngIf="enableFinancialCompanyOptions()" style="margin-bottom: 20px;">
      <p-header class="article-title">
        <div class="article-title">{{ "Empresa Faturamento" | translate }}</div>
      </p-header>
  
      <div class="form-group flex-row-between">
        <div class="form-control" style="width: 100%;">
          <label for="billingCompanyOptionId">{{ "Empresa Faturamento" | translate }}</label>
          <p-dropdown
            [options]="billingCompanyOptions"
            optionLabel="label"
            name="billingCompanyOptionId"
            appendTo="body"
            formControlName="billingCompanyOptionId"
            [showClear]="true"
          >
          </p-dropdown>
        </div>
      </div>
    </p-fieldset>
    
    <p-fieldset style="margin-top: 20px;">
      <p-header class="article-title">
        <div class="article-title">{{ "Nota Fiscal" | translate }}</div>
      </p-header>
  
      <div class="form-group flex-row-between">
        <div class="form-control" style="width: 100%;">
          <label for="issRetidoFonte">{{ "ISS-RETIDO" | translate }}</label>
          <p-inputSwitch
            name="issRetidoFonte"
            formControlName="issRetidoFonte"
          >
          </p-inputSwitch>
        </div>
      </div>
    </p-fieldset>
    
    <!-- Botões de ação - sempre visíveis -->
    <div class="form-group align-center mt-3" style="margin-top: 20px;">
      <div class="buttons flex justify-content-center gap-2">
        
        <p-button class="save-button align-center" label="{{ 'SAVE' | translate }}" type="button" (click)="save()" styleClass="p-button-primary"></p-button>
      </div>
    </div>
  </div>